import React from 'react';
import {connect} from 'react-redux';
import classnames from 'classnames';
import store from 'store';

import {
    Collapse,
    DropdownItem, DropdownMenu, DropdownToggle,
    Nav, Dropdown, NavItem, NavLink,
    Navbar, NavbarBrand, NavbarToggler
} from 'reactstrap';
import {Link} from 'react-router';

import {logoutUser} from '../authentication/actions/authentication';

import BlueHouseLogo from '../../components/media/logos/BlueHouseLogo.png';

class UniversalHeader extends React.Component {
    state = {
        dropdownOpen: false,
        mobileOpen: false,
        applicationTooltip: false
    };

    toggleNavbarDropdown = () => {
        this.setState({dropdownOpen: !this.state.dropdownOpen});
    };

    toggleNavbarMobile = () => {
        this.setState({mobileOpen: !this.state.mobileOpen});
    };

    toggleApplicationTooltip = () => {
        this.setState({applicationTooltip: !this.state.applicationTooltip});
    };

    render() {
        const {
            first_name,
            last_name,
            logoutUser,
            showNavbar,
            payment_method_on_file,
            email_verified,
            phone_verified
        } = this.props;

        const {
            dropdownOpen,
            mobileOpen
        } = this.state;

        let navbarLinks;

        switch (store.get('type')) {
            case 'tenant':
                navbarLinks = (
                    <Nav className="mr-auto" navbar>
                        <NavItem><NavLink tag={Link} to={'/dashboard/'} activeClassName="active">Dashboard</NavLink></NavItem>
                        <NavItem><NavLink tag={Link} to={'/explore/'} activeClassName="active">Explore</NavLink></NavItem>
                        <NavItem><NavLink id="app_tooltip" tag={Link} to={'/application/'} activeClassName="active">Application</NavLink></NavItem>
                    </Nav>
                );
                break;

            case 'landlord':
                navbarLinks = (
                    <Nav className="mr-auto" navbar>
                        <NavItem><NavLink tag={Link} to={'/dashboard/'} activeClassName="active">My Properties</NavLink></NavItem>
                        <NavItem><NavLink tag={Link} to={'/applications/'} activeClassName="active">Applications</NavLink></NavItem>
                    </Nav>
                );
                break;

            default:
                navbarLinks = null;
                break;
        }

        if (showNavbar) {
            return (
                <Navbar color="primary" light expand="sm">
                    <NavbarBrand tag={Link} to={'/dashboard/'}>
                        <img src={BlueHouseLogo} className="header-logo" alt="PolyRents"/>
                    </NavbarBrand>
                    <NavbarToggler onClick={this.toggleNavbarMobile}/>
                    <Collapse isOpen={mobileOpen} navbar>
                        {navbarLinks}

                        <Nav className="ml-auto" navbar>
                            {
                                !!store.get('type') ? (<Dropdown nav isOpen={dropdownOpen} toggle={this.toggleNavbarDropdown}>
                                    <DropdownToggle nav caret>
                                    <span className={classnames({
                                        'text-danger': (store.get('type') === 'landlord' && !email_verified) || (store.get('type') === 'tenant' && !phone_verified),
                                        'text-warning': (store.get('type') === 'tenant' && (phone_verified && !payment_method_on_file))
                                    })}>
                                       {
                                           first_name ? (first_name + ' ' + last_name + ' ') : 'My Account'
                                       }

                                        {
                                            (store.get('type') === 'landlord' && !email_verified) && <i className="fa fa-exclamation-circle"/>
                                        }

                                        {
                                            (store.get('type') === 'tenant' && !phone_verified) && <i className="fa fa-exclamation-circle"/>
                                        }

                                        {
                                            (store.get('type') === 'tenant' && (phone_verified && !payment_method_on_file)) && <i className="fa fa-exclamation-triangle"/>
                                        }

                                    </span>

                                    </DropdownToggle>
                                    <DropdownMenu>
                                        <DropdownItem tag={Link} to='/dashboard/'>Dashboard</DropdownItem>
                                        <DropdownItem tag={Link} to='/settings/'>
                                        <span className={classnames({'text-danger': (store.get('type') === 'landlord' && !email_verified) || (store.get('type') === 'tenant' && !phone_verified)})}>
                                        Account {((store.get('type') === 'landlord' && !email_verified) || (store.get('type') === 'tenant' && !phone_verified)) &&
                                        <i className="fa fa-exclamation-circle"/>}
                                        </span>
                                        </DropdownItem>
                                        {
                                            store.get('type') === 'tenant' ? (
                                                <DropdownItem tag={Link} to='/billing/'>
                                                <span className={classnames({'text-warning': !payment_method_on_file})}>
                                                    Billing {!payment_method_on_file && (<i className="fa fa-exclamation-triangle"/>)}
                                                </span>
                                                </DropdownItem>
                                            ) : null
                                        }

                                        <DropdownItem divider/>
                                        <DropdownItem tag={Link} to='/login' onClick={logoutUser}>Logout</DropdownItem>
                                    </DropdownMenu>
                                </Dropdown>) : (
                                    <NavItem><NavLink tag={Link} to={'/register/'} activeClassName="active">Login/Create Account</NavLink></NavItem>
                                )
                            }

                        </Nav>
                    </Collapse>
                </Navbar>
            );
        }
        else {
            return null;
        }
    }
}

function mapStateToProps(state) {
    return {
        first_name: state.activeUser.first_name,
        last_name: state.activeUser.last_name,
        user_type: state.activeUser.user_type,
        showNavbar: state.display.navbar.showNavbar,
        application: state.tenant.application,
        payment_method_on_file: state.tenant.billing && state.tenant.billing.status && state.tenant.billing.status.payment_method_on_file,
        email_verified: state.owner.email_verified,
        phone_verified: state.tenant.phone_verified
    };
}

const mapDispatchToProps = (dispatch) => ({
    logoutUser() {
        return dispatch(logoutUser());
    }
});

export default connect(mapStateToProps, mapDispatchToProps)(UniversalHeader);



// WEBPACK FOOTER //
// ./src/containers/navigation/UniversalHeader.js